import { render, staticRenderFns } from "./MomentListedListComponent.vue?vue&type=template&id=187fc6bc&scoped=true&"
import script from "./MomentListedListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentListedListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentListedListComponent.vue?vue&type=style&index=0&id=187fc6bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187fc6bc",
  null
  
)

export default component.exports